class MNotifyMe extends HTMLElement {
  constructor() {
    super();
    this.isAppInstalled = false;
  }

  static async sleep(time) {
    await new Promise((resolve) => setTimeout(resolve, time));
  }

  async connectedCallback() {
    await this.constructor.sleep(10);

    if (!document.querySelector('bis-button')) {
      await this.connectedCallback();
    } else {
      this.isAppInstalled = true;
      this.init();
    }
  }

  init() {
    this.submitButton = this.querySelector('[name="add"]');
    this.originalButton = document.querySelector('bis-button');
    this.submitButton.disabled = false;

    this.submitButton.addEventListener('click', (e) => {
      if (this.originalButton && this.dataset.variantAvailable === 'false') {
        e.preventDefault();
        this.originalButton.click();
        this.updateModal();
        this.updateSuccessScreen();
      }
    });
  }

  updateModal() {
    this.popup = document.querySelector('bis-popup');
    this.container = this.popup.querySelector('.container');
    this.heading = this.container.querySelector('.title');
    this.variantSelect = this.container.querySelector('.form-group.variant select');
    this.nameInput = this.container.querySelector('.form-group.name input');
    this.emailInput = this.container.querySelector('.form-group.email input');
    this.submitButton = this.container.querySelector('.product-form--atc-button');
    this.exitButton = this.container.querySelector('.close');

    this.variantLabel = document.createElement('label');
    this.nameLabel = document.createElement('label');
    this.emailLabel = document.createElement('label');
    this.buttonsWrapper = document.createElement('div');
    this.cancelButton = document.createElement('button');

    this.cancelButton.textContent = this.dataset.cancelButton;
    this.cancelButton.classList.add('btn', 'btn--secondary');
    this.cancelButton.addEventListener('click', () => {
      this.exitButton.click();
    });

    this.buttonsWrapper.classList.add('m-btns');
    this.submitButton.parentNode.replaceChild(this.buttonsWrapper, this.submitButton);
    this.buttonsWrapper.appendChild(this.cancelButton);
    this.buttonsWrapper.appendChild(this.submitButton);

    if (this.variantSelect) {
      this.variantLabel.classList.add('label');
      this.variantLabel.textContent = this.dataset.variantLabel;
      this.variantSelect.parentNode.replaceChild(this.variantLabel, this.variantSelect);
      this.variantLabel.parentNode.appendChild(this.variantSelect);
    }

    if (this.nameInput) {
      this.nameLabel.classList.add('label');
      this.nameLabel.textContent = this.dataset.nameLabel;
      this.nameInput.parentNode.insertBefore(this.nameLabel, this.nameInput);
    }

    this.emailLabel.classList.add('label');
    this.emailLabel.textContent = this.dataset.emailLabel;
    this.emailInput.parentNode.parentNode.insertBefore(this.emailLabel, this.emailInput.parentNode);
  }

  updateSuccessScreen() {
    this.successText = document.createElement('p');
    this.successText.textContent = this.dataset.successText;
    this.successText.classList.add('m-success-info', 'info');

    this.closeButton = document.createElement('button');
    this.closeButton.textContent = this.dataset.closeButton;
    this.closeButton.classList.add('m-close-button', 'btn', 'btn--secondary');
    this.closeButton.addEventListener('click', () => {
      this.exitButton.click();
    });

    this.successIcon = document.createElement('div');
    this.successIcon.classList.add('m-success-icon');

    this.exitButton.innerHTML = `
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2374 14.0001L21.2184 8.01916L19.9809 6.78173L14 12.7627L8.01906 6.78173L6.78162 8.01916L12.7626 14.0001L6.78162 19.9811L8.01906 21.2185L14 15.2375L19.9809 21.2185L21.2184 19.9811L15.2374 14.0001Z" fill="black"/>
      </svg>
    `;
    this.exitButton.remove();

    this.container.appendChild(this.exitButton);
    this.container.appendChild(this.successIcon);
    this.container.appendChild(this.successText);
    this.container.appendChild(this.closeButton);
  }
}

customElements.define('m-notify-me', MNotifyMe);
